import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://9625c6bef9b73809fe8c6e188cbd969a@o4508973823426560.ingest.de.sentry.io/4509252292771920",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
});
